import React from 'react'
import { Locations } from 'EstraSuppliers'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'
import { useLocationFields } from '../useLocationFields'
import { FormGrid } from 'app/components/shared/FormGrid'
import { SmartInput } from 'app/components/formik/Input'
import { FormSection } from 'app/components/shared/FormSection'
import { SmartDatePicker } from 'app/components/formik/DatePicker'

interface Props {
  locations: Locations
  holderWho:
    | 'holder_address'
    | 'technical_director_address'
    | 'technical_manager_address'
}
export const Holder: React.FC<Props> = ({ locations, holderWho }) => {
  const { values, setValues, setFieldValue } = useFormikContext<
    ProfileFormValues
  >()

  const makeHolderFieldName = (fieldName: string) => `${holderWho}.${fieldName}`

  const selectedProvice = values[holderWho].province_id
  const fieldCityName = makeHolderFieldName('city_id')

  const { provinceOptions, cityOptions } = useLocationFields(
    locations,
    selectedProvice
  )

  // when holder_address data changes, update primary bank details data with the ones in this older
  // only if primary bank details are empty
  const updatePrimaryBankDetailsData = () => {
    if (holderWho !== 'holder_address') return

    // Update data only if bank account data has not been setted yet
    if (
      values.bank_account_1 &&
      values.bank_account_1.delegated_fiscal_code === '' &&
      values.bank_account_1.delegated_name === '' &&
      values.bank_account_1.delegated_role === '' &&
      values.bank_account_1.delegated_surname === ''
    ) {
      const updatedValues = {
        ...values,
        bank_account_1: {
          ...values.bank_account_1,
          delegated_fiscal_code: values.holder_address.fiscal_code,
          delegated_name: values.holder_address.name,
          delegated_surname: values.holder_address.surname,
          delegated_role: 'delegato',
        },
      }
      setValues(updatedValues)
    }
  }

  return (
    <FormSection>
      <FormGrid cols={[6, 6]}>
        <SmartInput
          label='Nome'
          name={makeHolderFieldName('name')}
          onBlur={updatePrimaryBankDetailsData}
          required
        />

        <SmartInput
          label='Cognome'
          onBlur={updatePrimaryBankDetailsData}
          name={makeHolderFieldName('surname')}
          required
        />
      </FormGrid>

      <FormGrid cols={[4, 4, 4]}>
        <SmartInput
          label='Codice fiscale'
          onBlur={updatePrimaryBankDetailsData}
          name={makeHolderFieldName('fiscal_code')}
          required
        />

        <SmartDatePicker
          label='Data di nascita'
          name={makeHolderFieldName('birth_date')}
          required
        />
        <SmartInput
          label='Comune di nascita'
          name={makeHolderFieldName('birth_place')}
          required
        />
      </FormGrid>

      <FormGrid cols={[8, 2, 2]}>
        <SmartInput
          label='Indirizzo di residenza'
          name={makeHolderFieldName('address_street')}
          required
        />

        <SmartInput
          label='Civico'
          name={makeHolderFieldName('address_number')}
          required
        />

        <SmartInput
          label='CAP'
          name={makeHolderFieldName('postal_code')}
          required
        />
      </FormGrid>

      <FormGrid cols={[6, 6]}>
        <SmartInput
          type='select'
          label='Provincia'
          name={makeHolderFieldName('province_id')}
          required
          selectCaretSize='small'
          // reset company city when company province changes
          onChange={() => setFieldValue(fieldCityName, '')}
        >
          <option value={''}>Seleziona</option>
          {provinceOptions.map(province => (
            <option key={province.value} value={province.value}>
              {province.label}
            </option>
          ))}
        </SmartInput>

        <SmartInput
          type='select'
          label='Comune'
          name={makeHolderFieldName('city_id')}
          required
          selectCaretSize='small'
          disabled={!cityOptions.length}
        >
          <option value={''}>Seleziona</option>
          {cityOptions.map(city => (
            <option key={city.value} value={city.value}>
              {city.label}
            </option>
          ))}
        </SmartInput>
      </FormGrid>
    </FormSection>
  )
}
